import { Navigate } from 'react-router';

import { useCurrentUser, useUserDocument } from '@chartai/api-client';

import { LoadingSpinner } from '@/shared/components/feedback/LoadingSpinner';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { user, isLoading } = useCurrentUser();
  const { data: userDoc, isLoading: userDocLoading } = useUserDocument(user?.uid ?? null);

  if (isLoading || (user && userDocLoading)) {
    return <LoadingSpinner size="lg" className="min-h-screen" />;
  }

  if (!user) {
    return <Navigate to="/auth/signin" replace />;
  }

  if (userDoc?.['isTerminated'] === true) {
    return <Navigate to="/account-termination" replace />;
  }

  // CAB-526: No subscription/trial-expiry feature gate. Every plan (incl. Free)
  // grants full feature access — only monthly usage minutes differ between plans —
  // so the frontend never blocks app access on expiry. (Previously an expired-trial
  // Free user was bounced from /dashboard/profiles back to /subscriptions here.)
  return <>{children}</>;
}
